import { useState, useEffect } from 'react';
import axios from 'axios';
import LeftNav from '../components/Leftnav';
import TopBar from '../components/Topbar';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import '../css/Addacgroup.css';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useDispatch } from 'react-redux';
import { fetchCars } from '../redux/cars/carSlice';
import { useUser, useToken } from '../components/auth';
import InfoIcon from '@mui/icons-material/Info';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { useNavigate } from 'react-router';
import moment from 'moment';
import GetAppIcon from '@mui/icons-material/GetApp';
import writeXlsxFile from 'write-excel-file';

export default function OtherExpenses() {
  const navigate = useNavigate();
  const url = process.env.REACT_APP_BASE_URL;
  const [token] = useToken();
  const user = useUser();
  const { id, location } = user;
  const dispatch = useDispatch();
  const [locations, setLocations] = useState([]);
  const [locationNew, setLocationNew] = useState(location);
  const [locationSearch, setLocationSearch] = useState(0);
  const [searchType, setSearchType] = useState(' ');
  const [searchMessage, setSearchMessage] = useState('');
  const [depenseTypes, setDepenseTypes] = useState([]);
  const [depsenseType, setDepenseType] = useState('');
  useEffect(() => {
    async function locationsList() {
      try {
        const config = {
          method: 'get',
          maxBodyLength: Infinity,
          url: `${url}/otherdepensetypes`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
          },
        };

        const { data } = await axios.request(config);
        setDepenseTypes(data);
      } catch (error) {
        console.log(error);
      }
    }
    locationsList();
  }, [token, url]);

  useEffect(() => {
    async function locationsList() {
      try {
        const config = {
          method: 'get',
          maxBodyLength: Infinity,
          url: `${url}/signup/locations`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
          },
        };

        const { data } = await axios.request(config);
        setLocations(data);
      } catch (error) {
        console.log(error);
      }
    }
    locationsList();
  }, [token, url]);

  function handleLocationChanges(event) {
    setLocationNew(event.target.value);
  }

  function handSaerchLocation(event) {
    setLocationSearch(event.target.value);
  }

  function handleSearchType(event) {
    setSearchType(event.target.value);
  }

  function handleTypeChanges(event) {
    setDepenseType(event.target.value);
  }

  useEffect(() => {
    dispatch(fetchCars(token));
  }, [dispatch, token]);
  const [message, setMessage] = useState('');
  // Getting existing users
  const [garageDataa, setGarageDataa] = useState([]);
  useEffect(() => {
    const userData = async () => {
      const time = moment().format().substring(0, 10);
      try {
        const config = {
          method: 'get',
          maxBodyLength: Infinity,
          url: `${url}/otherdepense?sdate=${time}&edate=${time}&location=0&type=`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
          },
        };

        const { data } = await axios.request(config);
        setGarageDataa(data);
      } catch (error) {
        console.log(error);
      }
    };
    userData();
  }, [token, url]);

  // searching

  async function search() {
    setGarageDataa([]);
    const sdate = document.querySelector('#s-date').value;
    const edate = document.querySelector('#e-date').value;
    if (sdate === '' || edate === '') {
      setSearchMessage('Please select start date and end date');
      document.querySelector('#searchMessage').style.color = 'red';
    } else {
      setSearchMessage('Tegereza.....');
      document.querySelector('#searchMessage').style.color = 'blue';

      try {
        const config = {
          method: 'get',
          maxBodyLength: Infinity,
          url: `${url}/otherdepense?sdate=${sdate}&edate=${edate}&location=${locationSearch}&type=${searchType}`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
          },
        };

        const { data } = await axios.request(config);
        setGarageDataa(data);
        if (data.depensesData.length !== 0) {
          setSearchMessage('');
        } else {
          setSearchMessage(`No data found from ${sdate} to ${edate}`);
          document.querySelector('#searchMessage').style.color = 'green';
        }
      } catch (error) {
        console.log(error);
        setSearchMessage('Error while retrieving data');
        document.querySelector('#searchMessage').style.color = 'red';
      }
    }
  }

  async function saveDepenses() {
    const datee = document.querySelector('#date').value;
    const amount = document.querySelector('#amount').value;
    const receiver = document.querySelector('#receiver').value;

    if (
      depsenseType === '' ||
      depsenseType === 0 ||
      amount === '' ||
      receiver === '' ||
      locationNew === ''
    ) {
      setMessage('Please fill out all the required fields');
      document.querySelector('#message').style.color = 'red';
    } else {
      setMessage('Tegereza.....');
      document.querySelector('#message').style.color = 'blue';
      try {
        const datass = JSON.stringify({
          datee: datee,
          depsenseType: depsenseType,
          amount: amount,
          location: locationNew,
          user: id,
          receiver,
        });
        const config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: `${url}/otherdepense`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
          },
          data: datass,
        };

        const { data } = await axios.request(config);
        if (data.message === 'Other Expense data added') {
          document.querySelector('#date').value = '';
          document.querySelector('#receiver').value = '';
          document.querySelector('#amount').value = 0;
          setMessage(data.message);
          setLocationNew(location);
          setDepenseType('');
          document.querySelector('#message').style.color = 'green';
        }
        setMessage(data.message);
      } catch (error) {
        console.log(error);
        setMessage(`Ntibishoboye gukunda`);
        document.querySelector('#message').style.color = 'red';
      }
    }
  }
  //totals

  let total = 0;
  let displayData = [];

  if (Object.keys(garageDataa).length !== 0) {
    let i = 0;
    displayData = garageDataa.depensesData.map((row) => {
      i++;
      total += parseInt(row.amount);
      const ti = row.time
        .toLocaleString('en-GB', {
          timeZone: 'Africa/Kigali',
        })
        .substring(0, 10);

      return { ...row, time: ti, i };
    });
  }
  // preparing data for export

  const HEADER_ROW = [
    {
      value: 'No',
      fontWeight: 'bold',
    },

    {
      value: 'Receiver',
      fontWeight: 'bold',
    },
    {
      value: 'Depsense',
      fontWeight: 'bold',
    },
    {
      value: 'Amount',
      fontWeight: 'bold',
    },
    {
      value: 'Location',
      fontWeight: 'bold',
    },
    {
      value: 'Date',
      fontWeight: 'bold',
    },
  ];
  //datas
  let rowss = [];
  rowss = displayData.map((row) => {
    return [
      {
        type: Number,
        value: row.i,
      },
      {
        value: row.receiver,
      },
      {
        value: row.depense_type,
      },
      {
        value: row.amount,
      },
      {
        value: row.location_name,
      },
      {
        value: row.time,
      },
    ];
  });
  //totals
  const TOTAL_ROW = [
    {
      value: 'TOTAL',
      fontWeight: 'bold',
    },

    {
      value: '',
      fontWeight: 'bold',
    },
    {
      value: '',
      fontWeight: 'bold',
    },
    {
      value: total,
      fontWeight: 'bold',
    },
    {
      value: '',
      fontWeight: 'bold',
    },
    {
      value: '',
      fontWeight: 'bold',
    },
  ];

  const data = [HEADER_ROW, ...rowss, TOTAL_ROW];
  async function exportData(d) {
    await writeXlsxFile(d, {
      fileName: 'Other-depense.xlsx',
    });
  }

  // displaying garages datas

  return (
    <div className="App">
      <div className="left-side">
        <LeftNav />
      </div>
      <div className="right-side">
        <div>
          <TopBar page="Other Expenses" />
        </div>
        {/* Tab here */}
        <br />

        <Tabs
          defaultActiveKey="depense"
          id="uncontrolled-tab-example"
          className="mb-2"
        >
          <Tab eventKey="depense" title="Other Depense">
            <div className="cars-add-btn-dv">
              <FormControl sx={{ m: 1, width: '20%', marginTop: 2.5 }}>
                <InputLabel id="demo-simple-select-label">Location</InputLabel>
                <Select
                  id="location_search"
                  label="Location*"
                  value={locationSearch}
                  onChange={handSaerchLocation}
                >
                  <MenuItem key={0} value={0}>
                    All locations
                  </MenuItem>
                  {locations.length !== 0 &&
                    locations.locationLists.map((loc) => (
                      <MenuItem key={loc.id} value={loc.id}>
                        {loc.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
              <FormControl sx={{ m: 1, width: '20%', marginTop: 2.5 }}>
                <InputLabel id="depense-label">Type</InputLabel>
                <Select
                  id="searchType"
                  label="Select*"
                  value={searchType}
                  onChange={handleSearchType}
                >
                  <MenuItem value=" ">All depense</MenuItem>
                  {depenseTypes.length !== 0 &&
                    depenseTypes.depenseTypesData.map((loc) => (
                      <MenuItem key={loc.id} value={loc.name}>
                        {loc.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
              <input
                style={{ height: '40px', marginTop: '30px' }}
                name="s-date"
                id="s-date"
                type="date"
              />
              <span style={{ width: '30px' }}> </span>
              <input
                style={{ height: '40px', marginTop: '30px' }}
                name="e-date"
                id="e-date"
                type="date"
              />
              <span style={{ width: '10px' }}> </span>
              <Button
                style={{ height: '40px', marginTop: '30px' }}
                onClick={search}
                variant="contained"
              >
                SEARCH
              </Button>
            </div>
            <div style={{ marginLeft: '20px' }}>
              <p id="searchMessage">{searchMessage}</p>
            </div>

            {Object.keys(garageDataa).length !== 0 && (
              <TableContainer component={Paper}>
                <Table
                  sx={{ minWidth: 650 }}
                  size="small"
                  aria-label="a dense table"
                >
                  <TableHead style={{ background: 'black' }}>
                    <TableRow className="">
                      <TableCell>
                        <h6 style={{ color: '#fff' }}>No</h6>
                      </TableCell>

                      <TableCell>
                        {' '}
                        <h6 style={{ color: '#fff' }}>Receiver</h6>
                      </TableCell>

                      <TableCell>
                        {' '}
                        <h6 style={{ color: '#fff' }}>Depsense</h6>
                      </TableCell>
                      <TableCell>
                        <h6 style={{ color: '#fff' }}>Amount</h6>
                      </TableCell>

                      <TableCell>
                        <h6 style={{ color: '#fff' }}>Location</h6>
                      </TableCell>
                      <TableCell>
                        <h6 style={{ color: '#fff' }}>Date</h6>
                      </TableCell>
                      <TableCell>
                        <h6>More</h6>
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {displayData.map((row) => (
                      <TableRow
                        key={row.id}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row.i}
                        </TableCell>
                        <TableCell>{row.receiver}</TableCell>
                        <TableCell>{row.depense_type}</TableCell>
                        <TableCell>{row.amount}</TableCell>
                        <TableCell>{row.location_name}</TableCell>
                        <TableCell>
                          {row.time
                            .toLocaleString('en-GB', {
                              timeZone: 'Africa/Kigali',
                            })
                            .substring(0, 10)}
                          {/* {row.time} */}
                        </TableCell>
                        <TableCell>
                          <Button
                            variant="outlined"
                            onClick={() =>
                              navigate('/otherdepensedata', { state: { row } })
                            }
                            startIcon={<InfoIcon />}
                          >
                            More
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                    <TableRow
                      sx={{
                        '&:last-child td, &:last-child th': { border: 0 },
                      }}
                    >
                      <TableCell>Total</TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell>
                        {new Intl.NumberFormat().format(total)}
                      </TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                    {Object.keys(garageDataa).length === 0 && (
                      <p>Loading........</p>
                    )}
                  </TableBody>
                </Table>
                <Button
                  variant="outlined"
                  onClick={() => exportData(data)}
                  startIcon={<GetAppIcon />}
                >
                  Export data
                </Button>
              </TableContainer>
            )}
          </Tab>
          <Tab eventKey="add" title="Add Other Depense">
            {/*Add user here */}
            <Box
              component="form"
              sx={{
                '& .MuiTextField-root': {
                  m: 1,
                  width: '30ch',
                  marginTop: '20px',
                },
              }}
              noValidate
              autoComplete="off"
            >
              <div>
                <TextField
                  id="receiver"
                  label="Receiver*"
                  type="text"
                  defaultValue=""
                />
                <TextField
                  id="type"
                  select
                  label="Select*"
                  value={depsenseType}
                  helperText="Description"
                  onChange={handleTypeChanges}
                >
                  {depenseTypes.length !== 0 &&
                    depenseTypes.depenseTypesData.map((loc) => (
                      <MenuItem key={loc.id} value={loc.name}>
                        {loc.name}
                      </MenuItem>
                    ))}
                </TextField>
              </div>

              <div>
                <TextField
                  id="amount"
                  label="Amount*"
                  type="number"
                  defaultValue="0"
                />
                <FormControl sx={{ m: 1, minWidth: 300, marginTop: 2.5 }}>
                  <InputLabel id="demo-simple-select-label">
                    Location*
                  </InputLabel>
                  <Select
                    id="location"
                    label="Location*"
                    value={locationNew}
                    onChange={handleLocationChanges}
                  >
                    {locations.length !== 0 &&
                      locations.locationLists.map((loc) => (
                        <MenuItem key={loc.id} value={loc.id}>
                          {loc.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </div>
              <div>
                <TextField id="date" type="date" defaultValue="" />
              </div>

              <p style={{ marginLeft: '15%' }} id="message">
                {message}
              </p>
              <div style={{ marginLeft: '20%', marginTop: '2%' }}>
                <Button variant="contained" onClick={saveDepenses}>
                  Save
                </Button>
              </div>
            </Box>

            {/* End of add a user */}
          </Tab>
        </Tabs>
        {/* Tabs ends here */}
      </div>
    </div>
  );
}
